import { render, staticRenderFns } from "./home.vue?vue&type=template&id=ec658fc8&scoped=true&lang=pug&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=ec658fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec658fc8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderLayout: require('/home/node/components/layoutHome/HeaderLayout.vue').default,FooterLayout: require('/home/node/components/layoutHome/FooterLayout.vue').default,CookiesSnackbar: require('/home/node/components/shared/CookiesSnackbar.vue').default})
